import React, { ChangeEvent, useState } from "react";
import {
  IUCNStatus,
  Organization,
  PopulationTrend,
  Role,
  Species,
  SpeciesCategory,
  User,
} from "../common/ObjectTypes";
import { AddIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import ChangePasswordModal from "./ChangePasswordModal";
import { getCurrentUser } from "../../helpers/authHeader";

type AddEditUserTypes = {
  user: User;
  roles: Role[];
  orgs: Organization[];
  errors: any;
  addUser: boolean;
  existingUser: boolean;
  onChangeSingleSelect: Function;
  onChange: Function;
  onSave: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onSelectUser: Function;
  onCancelEdit: Function;
  onChangeRoles: Function;
  onChangeOrgs: Function;
  onUpdatePassword: Function;
  onOpenPasswordModal: Function;
  onClosePasswordModal: Function;
  isModalOpen: boolean;
  // onDelete: Function;
};

const AddEditUser = ({
  user,
  roles,
  orgs,
  errors,
  onChange,
  onSave,
  onCancelEdit,
  onChangeSingleSelect,
  onChangeRoles,
  onChangeOrgs,
  onUpdatePassword,
  existingUser,
  isModalOpen,
  onClosePasswordModal,
  onOpenPasswordModal,
}: // onDelete,

AddEditUserTypes) => {
  const currentUser = getCurrentUser();
  const orgAdminRole = roles.find((role) => role.name === "OrgAdmin");

  const defaultRoles = currentUser.isSystemAdmin
    ? user.roles
      ? user.roles.map((role: any) => ({
          value: role.roleId ? role.roleId : role.id,
          label: role.name,
        }))
      : []
    : orgAdminRole
    ? [{ value: orgAdminRole.roleId, label: orgAdminRole.name }]
    : [];

  const defaultOrgs = currentUser.isSystemAdmin
    ? user.organizations
      ? user.organizations.map((org: any) => ({
          value: org.organizationId,
          label: org.name,
        }))
      : []
    : currentUser.organizations && currentUser.organizations.length > 0
    ? [
        {
          value: currentUser.organizations[0].organizationId,
          label: currentUser.organizations[0].name,
        },
      ]
    : [];

  const isDisabled = user.isSystemAdmin && !currentUser.isSystemAdmin;

  return (
    <div className="w-full my-4">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="font-bold text-center text-4xl mb-4">
            {existingUser ? "Edit User" : "Add User"}
          </h1>
        </div>
        {existingUser &&
          (currentUser.isSystemAdmin || currentUser.userId === user.userId) && (
            <>
              <div className="w-2/3 flex justify-end mb-2">
                <button
                  onClick={() => onOpenPasswordModal()}
                  className="bg-deepGreen-500 hover:bg-deepGreen-700 py-2 px-4 rounded"
                >
                  Update Password
                </button>
              </div>
              <ChangePasswordModal
                user={user}
                onChange={onChange}
                isOpen={isModalOpen}
                onClose={onClosePasswordModal}
                onSubmit={onUpdatePassword}
              />
            </>
          )}
        <div className="bg-grayScale-300 w-2/3">
          {errors.onSave && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <span className="block sm:inline">{errors.onSave}</span>
            </div>
          )}
          <div className="flex flex-col py-2">
            <div className="px-6">
              {/* name */}
              <div className="pb-2">
                <TextInput
                  name={"firstName"}
                  label={"First Name*"}
                  placeholder={""}
                  value={user.firstName || ""}
                  error={errors.firstName}
                  disabled={isDisabled}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <TextInput
                  name={"lastName"}
                  label={"Last Name*"}
                  placeholder={""}
                  value={user.lastName || ""}
                  error={errors.lastName}
                  disabled={isDisabled}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <TextInput
                  name={"email"}
                  label={"Email*"}
                  placeholder={""}
                  value={user.email || ""}
                  error={errors.email}
                  disabled={isDisabled}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <TextInput
                  name={"userName"}
                  label={"Username*"}
                  placeholder={""}
                  value={user.userName || ""}
                  error={errors.userName}
                  disabled={isDisabled}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                {currentUser.isSystemAdmin ? (
                  <div className="flex flex-col mb-2 ">
                    <SelectInput
                      name="roles"
                      label="Select Role*"
                      options={
                        roles
                          ? roles.map((role) => ({
                              value: role.roleId,
                              label: role.name,
                            }))
                          : []
                      }
                      onChange={(selectedOptions: any) =>
                        onChangeRoles(selectedOptions)
                      }
                      className="w-full"
                      defaultValue={defaultRoles || []}
                      isDisabled={isDisabled}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      isMulti={false}
                      errors={errors.species}
                    />{" "}
                  </div>
                ) : (
                  <div className="flex flex-col mb-2 ">
                    <SelectInput
                      name="roles"
                      label="Select Role*"
                      options={
                        roles
                          ? roles.map((role) => ({
                              value: role.roleId,
                              label: role.name,
                            }))
                          : []
                      }
                      onChange={(selectedOptions: any) =>
                        onChangeRoles(selectedOptions)
                      }
                      className="w-full"
                      defaultValue={defaultRoles || []}
                      isDisabled={true}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      isMulti={false}
                      errors={errors.species}
                    />{" "}
                  </div>
                )}
                <div className="mt-2">
                  {currentUser.isSystemAdmin ? (
                    <div className="flex flex-col mb-2 ">
                      <SelectInput
                        name="organizations"
                        label="Select Organization*"
                        options={orgs.map((org) => ({
                          value: org.organizationId,
                          label: org.name,
                        }))}
                        onChange={(selectedOptions: any) =>
                          onChangeOrgs(selectedOptions)
                        }
                        className="w-full"
                        defaultValue={defaultOrgs || []}
                        isDisabled={isDisabled}
                        isLoading={false}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                        errors={errors.organizations}
                      />{" "}
                    </div>
                  ) : (
                    <div className="flex flex-col mb-2 ">
                      <SelectInput
                        name="organizations"
                        label="Select Organization*"
                        options={orgs.map((org) => ({
                          value: org.organizationId,
                          label: org.name,
                        }))}
                        onChange={(selectedOptions: any) =>
                          onChangeOrgs(selectedOptions)
                        }
                        className="w-full"
                        defaultValue={defaultOrgs || []}
                        isDisabled={true}
                        isLoading={false}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                        errors={errors.organizations}
                      />{" "}
                    </div>
                  )}
                </div>
                {!isDisabled && (
                  <div className="py-2 flex flex-row justify-end">
                    {/* <button
                    className="cursor-pointer p-2 rounded cursor-pointer"
                    onClick={() => onDelete()}
                  >
                    <DeleteIcon />
                  </button> */}

                    <button
                      className="px-3 py-2 rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                      onClick={() => onCancelEdit()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit" // Change to submit type to handle div submission
                      className="px-3 py-2 ml-2 rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                      onClick={(
                        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                      ) => onSave(e)}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditUser;
